import { isMobile, isTablet } from "react-device-detect";

export const IS_DISPLAY_IN_NEW_TAB_PARAM = "isDisplayInNewTab";

export const isMobileOrTabletDevice = () => isMobile || isTablet;

export const getEffectiveIsDisplayInNewTab = (isDisplayInNewTab: boolean) =>
  isDisplayInNewTab && !isMobileOrTabletDevice();
